<template>
    <div class="landing-page-buy vld-parent">

        <element-loader
            v-if="loadingData"
            loading
        />
        <property-search
            v-else
            :landing-page="landingPage"
            :is-mortgage-available="isMortgageAvailable"
            :has-service-providers="hasServiceProviders"
        />
    </div>
</template>

<script>
    import './Buy.scss';
    import ShowNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
    import {mapGetters, mapActions} from 'vuex';
    import cloneDeep from 'lodash/cloneDeep';
    import PropertyMapMixin from "../../../Mixins/PropertyMapMixin";

    export const BUY_LANDING_PAGE_DATA = 'landing-page-buy:landing-page-data';
    export const PROPERTY_SEARCH_DISABLED_OPTION = 'PropertySearch:disabled-option-fallback';

    export default {
        name: "Buy",
        components: {
          PropertySearch: () => import('../../../components/PropertySearch/PropertySearch')
        },
        mixins: [ShowNotificationMixin, PropertyMapMixin],

        data: () => {
            return {
            };
        },

        computed: {
            loadingData() {
                return !(this.buySection && this.mapLocationSquare.length && this.mlsInfo);
            },

            ...mapGetters([
                'getBuyFilter',
            ])
        },

        beforeMount() {
            this.$bus.$on(PROPERTY_SEARCH_DISABLED_OPTION, this.handleDisabledOption);
            this.restoreFilterState();
        },

        async beforeDestroy() {
            this.$bus.$off(PROPERTY_SEARCH_DISABLED_OPTION, this.handleDisabledOption);
        },

        methods: {
            ...mapActions([
                'setDefaultMlsAbbreviation',
                'setDefaultMapCoordinates',
                'setBuyFilter',
            ]),

            async restoreFilterState() {
                let filter = this.getBuyFilter;

                if (!filter) {
                    this.filter.clear();
                    return;
                }

                Object.keys(filter).forEach((key) => {
                    if (this.filter.hasOwnProperty(key) && filter.hasOwnProperty(key)) {
                        this.filter[key] = filter[key];
                    }
                });
            },
        },

        async created() {
            await Promise.all([
                this.fetchBuySection(),
                this.fetchHomePurchaseProjectType(),
            ]);
        },

        watch: {
            filter: {
                deep: true,
                handler() {
                    this.setBuyFilter(cloneDeep(this.filter));
                }
            }
        }
    };
</script>
